import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class MedicationList extends RegisterColumn {
  static type = REGISTER_COLUMNS.MEDICATION_LIST

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Медикаментозное лечение',
        component: Combobox,
        props: {
          allowClear: true,
          options: [
            {
              label: 'Есть',
              value: true,
            },
            {
              label: 'Нет',
              value: false,
            },
          ],
        },
      },
      width: 200,
      dataIndex: 'has_medication_list',
      dataRender: has_medication_list => typeof has_medication_list === 'boolean' ? has_medication_list ? 'Есть' : 'Нет' : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters }) {
    return {
      control: {
        filters: typeof filters.has_medication_list === 'boolean'
          ? [{
            field: 'has_medication_list',
            value: String(filters.has_medication_list),
            operator: '=',
            invalid: false,
            fieldtype: 'TS',
          }]
          : [],
      },
    }
  }
}
